import { render } from "./tournament_prizes_section.vue?vue&type=template&id=47806f2c"
import script from "./tournament_prizes_section.vue?vue&type=script&lang=js"
export * from "./tournament_prizes_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__